(function($) {

	$.fn.singleModalDialogue = function() {

		var elem = $(this),
			placeholder = $('.js-global-modal-placeholder'),
			settings = {
				ID: 0,
				type: "",
				ajaxUrl: '/ajax/single-modal-dialogue.aspx'
			};

		var init = function() {
            // Parse settings
            settings = $.extend(true, {}, settings, elem.parseSettings());

			elem.on('click', function(evt) {
				evt.preventDefault();

				if(settings.ID > 0 && settings.type.length > 0) {

					$.ajaxHtml(settings.ajaxUrl + '?ID=' + settings.ID + '&type=' + settings.type, function(response) {
						placeholder.html(response);

						app.bind(placeholder);
					});
				}

			});
		};

		init();
		return this;

	};

}($));